import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { BlockBetween, BlockHeadContent, Col, Icon, Row } from '../../../../components/Component';
import { success_sign_out } from '../../../../reducers/dashboard_reducers/auth/sign_out_Slice';
import { success_client_sign_out } from '../../../../reducers/client_reducers/auth/sign_out_slice';
import TextInput from '../../../components/inputs/TextInput';
import { fail_resignin_otp, loading_resignin_otp, reset_resignin_otp, success_resignin_otp } from '../../../../reducers/dashboard_reducers/auth/resignin_otp_Slice';
import { SENT_OTP_AUTH_ERR_MSG, SENT_OTP_AUTH_SUCESS_MSG, VERIFY_OTP_AUTH_ERR_MSG, VERIFY_OTP_AUTH_SUCESS_MSG } from '../../../../constants/success_error_messages_consts';
import * as app_consts from "../../../../constants/react_app_consts";
import { RESIGNIN_DASHBOARD_USER_OTP_API, VERIFY_OTP_AUTH_API } from '../../../../api/api_data';
import { messageToast } from '../../../../utils/Utils';
import { useSelector } from 'react-redux';
import { employee_dashboard_actions_helper, website_actions_helper } from '../../../../actions/actions_helper';
import { fail_verify_resign_in_otp, loading_verify_resign_in_otp, reset_verify_resign_in_otp, success_verify_resign_in_otp } from '../../../../reducers/dashboard_reducers/auth/verify_resign_in_otp_Slice';
import { reset_sign_out_modal } from '../../../../reducers/dashboard_reducers/auth/sign_out_modal_Slice';

const ModalLogout = ({ logout_var }) => {

    const dispatch = useDispatch();
    const [modalTop, setModalTop] = useState(logout_var);
    const [otp_sent, setOtpSent] = useState(false);
    const [otp_error, setOtpError] = useState("");
    const [otp_loading, setOTPLoading] = useState(false);
    const [otp_value, setOTPValue] = useState('');
    const [resign_follow_up, setResignFollowUp] = useState(null);
    const [username, setUserName] = useState("");

    const toggleTop = () => {
        dispatch(success_sign_out());
        dispatch(success_client_sign_out());
    };

    const auth_sign_out_listener = useSelector((state) => state.sign_out_modal.sign_out_modal);

    useEffect(() => {
        if (auth_sign_out_listener?.status === app_consts.SUCCESS)
        {
            setResignFollowUp(auth_sign_out_listener?.data || null);
        }
    }, [auth_sign_out_listener]);

    useEffect(() => {
        setModalTop(logout_var);
        if (localStorage.getItem("log_cred"))
        {
            setUserName(JSON.parse(localStorage.getItem('log_cred')).username);
        }
    }, [logout_var]);


    const handleSendOtp = () => {
        setOtpError("");

        dispatch(website_actions_helper(loading_resignin_otp, success_resignin_otp, fail_resignin_otp, SENT_OTP_AUTH_ERR_MSG, SENT_OTP_AUTH_SUCESS_MSG, app_consts.GET, `${RESIGNIN_DASHBOARD_USER_OTP_API}/${username}`));
    };
    // //  Listen
    const resignin_otp_listener = useSelector((state) => state.resignin_otp.resignin_otp);

    useEffect(() => {
        if (resignin_otp_listener.status !== app_consts.IDLE)
        {
            if (resignin_otp_listener.status === app_consts.LOADING)
            {
                setOTPLoading(true);
                setOtpError("");
            } else
            {
                setOTPLoading(false);
                if (resignin_otp_listener.status === app_consts.FAIL)
                {
                    setOtpError(resignin_otp_listener.message, app_consts.FAIL);
                    messageToast(resignin_otp_listener.message, app_consts.FAIL);
                } else if (resignin_otp_listener.status === app_consts.SUCCESS)
                {
                    messageToast(SENT_OTP_AUTH_SUCESS_MSG, app_consts.SUCCESS);
                    setOtpSent(true);
                    setOTPValue("");
                }
                dispatch(reset_resignin_otp());
            }
        }
    }, [resignin_otp_listener]);

    // Handle Submit
    const handleSubmitOTP = () => {
        setOtpError("");
        const send_data = { username: username, otp: otp_value };
        dispatch(website_actions_helper(loading_verify_resign_in_otp, success_verify_resign_in_otp, fail_verify_resign_in_otp, VERIFY_OTP_AUTH_ERR_MSG, VERIFY_OTP_AUTH_SUCESS_MSG, app_consts.POST, `${VERIFY_OTP_AUTH_API}`, send_data));
    };
    //  Listen
    const verify_resign_in_otp_listener = useSelector((state) => state.verify_resign_in_otp.verify_resign_in_otp);

    const canReplayFollowUpRequest =
        typeof resign_follow_up?.loadingState === "function" &&
        typeof resign_follow_up?.successState === "function" &&
        typeof resign_follow_up?.failState === "function" &&
        Boolean(resign_follow_up?.apiReqType) &&
        Boolean(resign_follow_up?.apiEndpoint);

    useEffect(() => {
        if (verify_resign_in_otp_listener.status !== app_consts.IDLE)
        {
            if (verify_resign_in_otp_listener.status === app_consts.LOADING)
            {
                setOTPLoading(true);
                setOtpError("");
            } else
            {
                if (verify_resign_in_otp_listener.status === app_consts.FAIL)
                {
                    setOTPLoading(false);
                    setOtpError(verify_resign_in_otp_listener.message);
                    messageToast(verify_resign_in_otp_listener.message, app_consts.FAIL);
                } else if (verify_resign_in_otp_listener.status === app_consts.SUCCESS)
                {

                    const timer = setTimeout(() => {
                        if (canReplayFollowUpRequest)
                        {
                            dispatch(employee_dashboard_actions_helper(resign_follow_up?.loadingState, resign_follow_up?.successState, resign_follow_up?.failState, resign_follow_up?.errorMessage, resign_follow_up?.successMessage, resign_follow_up?.apiReqType, resign_follow_up?.apiEndpoint, resign_follow_up?.formData));
                        }

                        setOtpSent(false);
                        setOTPValue("");
                        setOtpError("");
                        setModalTop(false);
                        setOTPLoading(false);
                        setResignFollowUp(null);
                        dispatch(reset_sign_out_modal());

                        if (!canReplayFollowUpRequest)
                        {
                            window.location.reload();
                        }
                    }, 1500);

                    return () => clearTimeout(timer); // cleanup in case the component unmounts
                }
                dispatch(reset_verify_resign_in_otp());
            }
        }
    }, [canReplayFollowUpRequest, dispatch, resign_follow_up, verify_resign_in_otp_listener]);

    return (
        <>
            <Modal isOpen={modalTop} className="modal-dialog-top">
                <ModalHeader
                    toggle={toggleTop}
                >
                    Session Expired
                </ModalHeader>
                <ModalBody>
                    <p>
                        Please Sign in Again to Continue Using the System.
                    </p>
                    <Row className="g-4">
                        <TextInput
                            label="OTP"
                            type="text"
                            id_val="name"
                            value={otp_value}
                            colSize="12"
                            required
                            name="name"
                            disabled={!otp_sent}
                            handleChange={(e) => setOTPValue(e.target.value)}
                        />
                    </Row>
                    <Row className="g-2 mt-1">

                        {otp_error && (
                            <div className="mb-3">
                                <Alert color="danger" className="alert-icon">
                                    <Icon name="alert-circle" /> {otp_error}
                                </Alert>
                            </div>
                        )}
                        <Col xl="12" className="d-flex justify-content-end">
                            {
                                otp_sent ?
                                    <>
                                        <div className="form-group">
                                            <Button
                                                color="primary"
                                                size="lg"
                                                className="btn-block"
                                                disabled={otp_loading || !otp_value}
                                                onClick={handleSubmitOTP}
                                            >
                                                {otp_loading ? <Spinner size="sm" color="light" /> : 'Verify OTP'}
                                            </Button>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="form-group">
                                            <Button
                                                color="primary"
                                                size="lg"
                                                className="btn-block"
                                                disabled={otp_sent ? otp_loading || !otp_value : false}
                                                onClick={handleSendOtp}
                                            >
                                                {otp_loading ? <Spinner size="sm" color="light" /> : 'Send OTP'}
                                            </Button>
                                        </div>
                                    </>
                            }
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className="bg-light d-flex justify-content-start">
                    <BlockBetween>
                        <BlockHeadContent>
                            <Button onClick={toggleTop} color="danger">
                                Sign Out
                            </Button>
                        </BlockHeadContent>
                    </BlockBetween>
                </ ModalFooter>
            </Modal>
        </>
    );
};
        
export default ModalLogout;
